<template>
  <div class="w-container">
    <div class="power-curve">
      <div class="power-curve-item">
        <span>湍流：</span>
        <el-select
          v-model="turbulentValue"
          placeholder="湍流"
          size="mini"
          filterable
          default-first-option
          @change="turbulentChange"
          :popper-append-to-body="false"
        >
          <el-option
            v-for="item in turbulentOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="power-curve-item">
        <span style="vertical-align: middle">空气密度（kg/m&sup3;）：</span>
        <el-select
          v-model="wspdValue1"
          placeholder="空气密度"
          size="mini"
          @change="selectChange"
        >
          <el-option
            v-for="item in wspdOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :popper-append-to-body="false"
          >
          </el-option>
        </el-select>
      </div>
      <div class="power-curve-item">
        <span>空气密度（kg/m&sup3;）：</span>
        <el-select
          v-model="wspdValue2"
          placeholder="空气密度"
          size="mini"
          @change="selectChange"
        >
          <el-option
            v-for="item in wspdOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :popper-append-to-body="false"
          >
          </el-option>
        </el-select>
      </div>
      <div class="power-curve-item" style="text-align: left">
        <span>插值空气密度：</span>
        <el-input
          type="number"
          placeholder="请输入"
          v-model="wspdInput"
          size="mini"
        >
        </el-input>
      </div>
      <div class="power-curve-item" style="text-align: left">
        <el-button
          type="primary"
          size="mini"
          @click="changePowerCurve"
          :disabled="changeCurveDisable"
          >插值</el-button
        >
        <el-button
          :disabled="saveBtndisabled"
          type="primary"
          @click="save"
          size="mini"
          >保存</el-button
        >
      </div>
    </div>
    <div class="empty" v-if="empty">
      暂无数据
    </div>
    <div class="power-curve-change" v-else>
      <div
        v-if="Object.keys(powerCurvedataMore).length > 0"
        v-loading="tableLoading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        class="res-chart"
      >
        <echart
          :option="powercurvesOptions"
          :notMerge="true"
          :divStyle="{ height: '400px', width: '99%' }"
        ></echart>
      </div>
      <el-table
        v-if="powerCurveMoreTableData.length > 0"
        :data="powerCurveMoreTableData"
        border
        key="2"
        size="mini"
        style="margin: 0 auto 50px;width: 90%"
        v-loading="tableLoading"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column label="风速（m/s）" prop="wspd"></el-table-column>
        <template v-if="!changeCurve">
          <el-table-column
            v-for="(item, index) in columns"
            :label="item.label"
            :key="index"
            :prop="item.prop"
          >
          </el-table-column>
        </template>
        <template v-if="changeCurve">
          <el-table-column
            v-for="(item, index) in changeColumns"
            :label="item.label"
            :key="index"
            :prop="item.prop"
          >
          </el-table-column>
        </template>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  filterCurveMoreTableData,
  filterPowerCurveMoreData,
  filterChangeCurveData,
  filterChangeTableData
} from '../../helper/filter';
import { mapState } from 'vuex';
import isEmpty from 'lodash/isEmpty';
import { getToken } from '@/utils';

export default {
  props: {},
  components: {},
  data() {
    return {
      tableLoading: false,
      // 湍流设置
      turbulentValue: null,
      turbulentOptions: [],
      // 空气密度设置
      wspdValue1: null,
      wspdValue2: null,
      wspdOptions: [],
      // 图表类型
      subtypeValue: '1',
      subtypeOptions: [
        {
          value: '1',
          label: '功率（KW）'
        },
        {
          value: '2',
          label: '推力系数'
        },
        {
          value: '3',
          label: 'cp'
        }
      ],
      wspdInput: '',
      changeCurveDisable: true,
      powerCurveMoreTableData: [],
      powerCurvedataMore: {},
      // 多条功率曲线原始数据
      curveMoreData: [],
      // 功率曲线转换原始数据
      curveChangeData: {},
      // 是否显示差值空气密度
      changeCurve: false,
      // 有无数据
      empty: false,
      powercurvesOptions: null,
      conversionPowerCurve: [],
      saveBtndisabled: true,
      startWspdValue: false,
      startTurbulence: false
    };
  },
  computed: {
    ...mapState('model', [
      'checkedList',
      'modelList',
      'menuRightType',
      'currentModel'
    ]),
    // 对比功率曲线的列数据
    columns() {
      if (isEmpty(this.curveMoreData)) return [];
      const cols = [];
      this.curveMoreData.forEach((eco, i) => {
        // let num = i + 1;
        let str =
          i === 0
            ? `空气密度${eco[0].density}（kg/m³）`
            : `空气密度${eco[0].density}（kg/m³） `;
        cols.push({
          label: str,
          prop: `power${i === 0 ? '' : i}`
        });
      });
      return cols;
    },
    changeColumns() {
      if (isEmpty(this.curveChangeData)) return [];
      const cols = [];
      for (let key in this.curveChangeData) {
        if (key === 'powerCurve1' && this.curveChangeData[key].length > 1) {
          cols.push({
            label: '空气密度' + this.wspdValue1,
            prop: `power`
          });
        }
        if (key === 'powerCurve2' && this.curveChangeData[key].length > 1) {
          cols.push({
            label: '空气密度' + this.wspdValue2,
            prop: `power1`
          });
        }
        if (
          key === 'conversionPowerCurve' &&
          this.curveChangeData[key].length > 1
        ) {
          cols.push({
            label: '插值空气密度',
            prop: `power2`
          });
        }
      }
      return cols;
    }
  },
  watch: {
    // turbulentValue() {
    //   if (this.changeCurve) {
    //     return this.fetchChangePowerCurve();
    //   }
    //   this.fetch();
    // },
    // wspdValue1() {
    //   if (this.changeCurve) {
    //     return this.fetchChangePowerCurve();
    //   }
    //   if (this.startWspdValue) {
    //     return;
    //   }
    //   this.fetchPowerCurveMore();
    // },
    // wspdValue2() {
    //   if (this.changeCurve) {
    //     return this.fetchChangePowerCurve();
    //   }
    //   if (this.startWspdValue) {
    //     return;
    //   }
    //   this.fetchPowerCurveMore();
    // },
    wspdInput(value) {
      if (value) {
        this.changeCurveDisable = false;
      } else {
        this.changeCurveDisable = true;
      }
    },
    // 当前选中的机型
    currentModel(val) {
      this.startTurbulence = false;
      this.startWspdValue = false;
      if (this.menuRightType === 7) {
        this.idList = [val.turbineTypeId];
        // if (!this.changeCurveDisable) {
        //   this.fetchPowerCurveDensityList();
        //   this.fetchPowerCurveTurbulenceList();
        //   this.fetchChangePowerCurve();
        //   return;
        // }
        this.wspdInput = '';
        this.fetch();
      }
    }
  },
  methods: {
    turbulentChange() {
      this.saveBtndisabled = true;
      this.startTurbulence = true;
      this.fetch();
    },
    selectChange() {
      this.saveBtndisabled = true;
      this.startWspdValue = false;
      this.fetchPowerCurveMore();
    },
    async fetch() {
      if (this.tableLoading) {
        return;
      }
      this.wspdValue1 = null;
      this.wspdValue2 = null;
      // this.turbulentValue = null;
      this.tableLoading = true;
      try {
        await this.fetchPowerCurveTurbulenceList();
        await this.fetchPowerCurveDensityList();
        await this.fetchPowerCurveMore();
        // await Promise.all([
        //   this.fetchPowerCurveDensityList(),
        //   this.fetchPowerCurveTurbulenceList(),
        //   this.fetchPowerCurveMore()
        // ]);
      } catch (e) {
        this.tableLoading = false;
        throw e;
      }
      this.tableLoading = false;
    },
    // 获取功率曲线空气密度集合
    async fetchPowerCurveDensityList() {
      await this.$fetch('/windfarm/turbineType/getPowerCurveDensityList', {
        params: {
          turbineTypeId: this.idList[0],
          turbulence: this.turbulentValue
        },
        showError: true
      }).then(res => {
        if (res.code === 0) {
          let wspdOptionsArr = [];
          res.data.densityList.map(item => {
            let wspdOptionsObj = {};
            wspdOptionsObj.value = item.density;
            wspdOptionsObj.label = item.density;
            wspdOptionsArr.push(wspdOptionsObj);
          });
          //if (!this.startTurbulence) {
          this.wspdValue1 = wspdOptionsArr[0].value;
          this.wspdValue2 = wspdOptionsArr[0].value;
          this.wspdOptions = wspdOptionsArr;
          //}
          this.startWspdValue = true;
        }
      });
    },
    // 获取功率曲线湍流集合
    async fetchPowerCurveTurbulenceList() {
      await this.$fetch('/windfarm/turbineType/getPowerCurveTurbulenceList', {
        params: {
          turbineTypeId: this.idList[0]
        },
        showError: true
      }).then(res => {
        if (res.code === 0) {
          let turbulenceListArr = [];
          res.data.turbulenceList.map(item => {
            let turbulenceListObj = {};
            turbulenceListObj.value = item.turbulence;
            turbulenceListObj.label = item.turbulence;
            turbulenceListArr.push(turbulenceListObj);
          });
          if (!this.startTurbulence) {
            this.turbulentValue = turbulenceListArr[0].value;
            this.turbulentOptions = turbulenceListArr;
          }
        }
      });
    },
    // 获取不同空气密度下的功率曲线
    async fetchPowerCurveMore() {
      this.empty = false;
      if (typeof this.wspdValue1 !== 'number' && !this.wspdValue1) {
        return;
      }
      if (typeof this.wspdValue2 !== 'number' && !this.wspdValue2) {
        return;
      }
      if (typeof this.turbulentValue !== 'number' && !this.turbulentValue) {
        return;
      }
      // if (!this.changeCurveDisable) {
      //   return;
      // }
      this.tableLoading = true;
      let densitys = `${this.wspdValue1},${this.wspdValue2}`;
      await this.$fetch('/windfarm/turbineType/getCurveDataList', {
        params: {
          densitys,
          turbulences: this.turbulentValue,
          turbineTypeId: this.idList[0],
          type: this.subtypeValue
        },
        showError: true
      }).then(res => {
        if (res.code === 0) {
          if (!res.data.curveDataList) {
            this.powerCurveMoreTableData = [];
            this.powerCurvedataMore = {};
            this.tableLoading = false;
            this.empty = true;
            return;
          }
          this.powerCurveMoreTableData = [];
          this.$nextTick(() => {
            this.powerCurveMoreTableData = filterCurveMoreTableData(
              res.data.curveDataList
            );
          });
          this.powerCurvedataMore = filterPowerCurveMoreData(
            res.data.curveDataList,
            this.menuRightType
          );
          this.curveMoreData = res.data.curveDataList;
          this.$nextTick(function() {
            this.powerCurveMoreInit(this.powerCurvedataMore);
          });
          this.tableLoading = false;
        } else {
          this.tableLoading = false;
        }
      });
    },
    powerCurveMoreInit(data) {
      let legends = [];
      let serciesData = [];
      let str;
      if (this.curveChangeData && this.changeCurve && !this.saveBtndisabled) {
        for (let key in this.curveChangeData) {
          if (key === 'powerCurve1') {
            str = '空气密度' + this.wspdValue1;
            serciesData.push({
              name: str,
              type: 'line',
              data: data['powerCurve1']
            });
          }
          if (key === 'powerCurve2') {
            str = '空气密度' + this.wspdValue2;
            serciesData.push({
              name: str,
              type: 'line',
              data: data['powerCurve2']
            });
          }
          if (key === 'conversionPowerCurve') {
            str = '插值空气密度';
            serciesData.push({
              name: str,
              type: 'line',
              data: data['conversionPowerCurve']
            });
          }
          legends.push(str);
        }
      } else {
        this.curveMoreData.forEach((item, i) => {
          // let num = i + 1;
          let str =
            i === 0
              ? `空气密度${item[0].density}`
              : `空气密度${item[0].density} `;
          //let str = '空气密度'+ item.density;
          legends.push(str);
        });
        serciesData = this.curveMoreData.map((item, index) => {
          return {
            name: legends[index],
            type: 'line',
            data: data[index]
          };
        });
      }

      this.powercurvesOptions = {
        xAxis: {
          name: '风速(m/s)',
          type: 'value',
          splitNumber: 5,
          min: 0,
          max: 25,
          axisLine: {
            lineStyle: {
              type: 'solid',
              color: '#fff'
            },
            onZero: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        tooltip: {
          trigger: 'axis'
          // formatter: function(params) {
          //   //console.log(params);
          //   let res = '<span>' + params[0]['name'] + '</span>';
          //   for (var i = 0; i < params.length; i++) {
          //     res +=
          //       '<p>' +
          //       params[i].seriesName +
          //       '°:' +
          //       params[i].value[1] +
          //       '</p>';
          //   }
          //   return res;
          // }
        },
        backgroundColor: '#3b3a39',
        toolbox: {
          feature: {}
        },
        legend: {
          data: legends,
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          left: '3%',
          right: '8%',
          bottom: '3%',
          containLabel: true
        },
        yAxis: [
          {
            position: 'left',
            type: 'value',
            name: '功率（kW）',
            min: 0,
            max: value => {
              if (value.max <= 10) {
                return 10;
              }

              let max = value.max * 1.2;
              let val = max / 5;
              const round = true;
              const exponent = Math.floor(Math.log(val) / Math.LN10);
              const exp10 = Math.pow(10, exponent);
              const f = val / exp10; // 1 <= f < 10
              let nf;
              if (round) {
                if (f < 1.5) {
                  nf = 1;
                } else if (f < 2.5) {
                  nf = 2;
                } else if (f < 4) {
                  nf = 3;
                } else if (f < 7) {
                  nf = 5;
                } else {
                  nf = 10;
                }
              } else {
                if (f < 1) {
                  nf = 1;
                } else if (f < 2) {
                  nf = 2;
                } else if (f < 3) {
                  nf = 3;
                } else if (f < 5) {
                  nf = 5;
                } else {
                  nf = 10;
                }
              }
              val = nf * exp10;
              return val * 5 <= value.max ? val * 6 : val * 5;
            },
            axisLine: {
              lineStyle: {
                type: 'solid',
                color: '#fff'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed'
              }
            }
          }
        ],
        series: serciesData
      };
    },
    // 获取转换后的功率曲线
    async fetchChangePowerCurve() {
      this.tableLoading = true;
      this.empty = false;
      await this.$fetch('/windfarm/turbineType/getConversionPowerCurve', {
        params: {
          density1: this.wspdValue1,
          density2: this.wspdValue2,
          densityDifference: this.wspdInput,
          turbulence: this.turbulentValue,
          turbineTypeId: this.idList[0]
        },
        showError: true
      })
        .then(res => {
          if (res.code === 0) {
            if (
              res.data['powerCurve1'].length < 1 &&
              res.data['powerCurve2'].length < 1 &&
              res.data['conversionPowerCurve'].length < 1
            ) {
              this.powerCurveMoreTableData = [];
              this.powerCurvedataMore = {};
              this.conversionPowerCurve = [];
              this.tableLoading = false;
              this.empty = true;
              return;
            }
            this.conversionPowerCurve = res.data.conversionPowerCurve;
            this.powerCurveMoreTableData = [];
            this.$nextTick(() => {
              this.powerCurveMoreTableData = filterChangeTableData(res.data);
            });
            this.powerCurvedataMore = filterChangeCurveData(res.data);
            this.curveChangeData = res.data;
            this.$nextTick(() => {
              this.powerCurveMoreInit(this.powerCurvedataMore);
            });
            this.tableLoading = false;
          } else {
            this.tableLoading = false;
            this.$message({
              message: res.message,
              type: 'warning'
            });
          }
        })
        .catch(e => {
          this.changeCurve = false;
          this.tableLoading = false;
          throw e;
        });
    },
    changePowerCurve() {
      if (this.wspdValue1 == this.wspdValue2) {
        this.$message({
          message: '两个空气密度不能一样,请重新选择！',
          type: 'warning'
        });
        return;
      }
      if (this.wspdValue1 < this.wspdValue2) {
        if (
          this.wspdInput <= this.wspdValue1 ||
          this.wspdInput >= this.wspdValue2
        ) {
          this.$message({
            message: '插值的空气密度需要介于选定的空气密度之间!',
            type: 'warning'
          });
          return;
        }
      } else {
        if (
          this.wspdInput >= this.wspdValue1 ||
          this.wspdInput <= this.wspdValue2
        ) {
          this.$message({
            message: '插值的空气密度需要介于选定的空气密度之间!',
            type: 'warning'
          });
          return;
        }
      }

      this.changeCurve = true;
      this.saveBtndisabled = false;
      this.fetchChangePowerCurve();
    },
    async save() {
      this.conversionPowerCurve.forEach(item => {
        item.turbulence = this.turbulentValue;
      });
      let params = `apiKey=${getToken()}&density1=${this.wspdValue1}&density2=${
        this.wspdValue2
      }&densityDifference=${this.wspdInput}&turbineTypeId=${
        this.currentModel.turbineTypeId
      }`;
      let url = `/windfarm/turbineType/saveConversionPowerCurve?`;
      url = url + params;
      await this.$fetch({
        url,
        data: this.conversionPowerCurve,
        method: 'POST',
        showLoading: { mask: true },
        showError: true,
        showSuccess: true
      });
    }
  },
  mounted() {
    this.idList = [this.currentModel.turbineTypeId];
    this.fetch();
  }
};
</script>

<style lang="less" scoped>
.power-curve {
  position: relative;
  top: 30px;
  left: 20px;
  width: 100%;
  //z-index: 1000;
  //background-color: #0477a1;
  height: 40px;
  padding-left: 20px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  color: #fff;
  .power-curve-item:not(:first-child) {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /deep/ .el-input {
    padding: 0;
    margin: 0;
    width: 125px;
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }

    input[type='number'] {
      -moz-appearance: textfield;
    }
  }
  /deep/.el-input__inner {
    /*background-color: #0477a1;*/
    /*border: none;*/
    /*outline: none;*/
    /*color: #fff;*/
    background-color: #0477a1;
    border: none;
    border-bottom: 1px solid #fff;
    border-radius: 0;
    outline: none;
    color: #fff;
    padding: 0;
    margin: 0;
    width: 110px;
    text-align: center;
  }
  /deep/.el-input.is-focus > .el-input__inner {
    border-color: #fff;
  }
  /deep/.el-select .el-input .el-input__suffix {
    display: block;
  }
  /deep/.el-select__tags {
    max-width: 100% !important;
    /deep/.el-tag--info {
      background-color: transparent;
      border: none;
      color: #fff;
      /*text-align: center;*/
    }
  }
}
.empty {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(50%);
  font-size: 14px;
  color: #8f9197;
  text-align: center;
}
.power-curve-change {
  // max-height: 505px;
  // overflow-y: scroll;
  padding-top: 70px;
}
.res-chart {
  height: 400px;
  padding-bottom: 20px;
  width: 90%;
  margin: 15px auto 20px;
}
.e-container {
  height: 100%;
  width: 100%;
}
</style>
<style lang="less" scoped>
/deep/.el-table th.gutter {
  display: table-cell !important;
  border-bottom: 0;
}
/deep/.el-table thead.is-group th {
  background-color: #0477a1;
  color: #fff;
}
/deep/.el-table th {
  background-color: #0477a1;
  color: #fff;
}
/deep/.el-table tr:nth-of-type(odd) {
  background-color: #1e608f;
  color: #fff;
}
/deep/ .el-table tr:nth-of-type(even) {
  background-color: #126e6d;
  color: #fff;
}
/deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #0477a1;
}
/deep/.el-table__body tr.current-row > td {
  background-color: #0477a1;
}
</style>
